import React from "react";
import Convert from "../../common/Convert";
import InputBase from "./InputBase";
import {
    Input, Label
} from "reactstrap";

export default class InputCheckBoxWithUniqueKey extends InputBase {
    static defaultProps = {
        label:'',
        labelOn:false,
        name:'',
        className:'',
        style:{},        
        checkedValue:true,
        uncheckedValue:false,
        customStyle:"",
        uniqueKey:""
    }

    constructor(props) {
        super(props);
        this.state = {
            validate_message: '',
            valid: true,
            value: props.options?[]:false,
        };

        this.handle_change = this.handle_change.bind(this)
        this.handle_keyDown = this.handle_keyDown.bind(this)
    }

    handle_change(e) {
        const columnObject = Convert.key_split(this.props.name)
        const parentValueArray = (this.props.rootData.values&&this.props.rootData.values[columnObject.column])||[]
        const newValue = this.props.options?(
                e.target.checked?[...parentValueArray,e.target.value]:parentValueArray.filter((singleValue)=>singleValue!==e.target.value)
            ):(
                e.target.checked?this.props.checkedValue:this.props.uncheckedValue
            )
        this.validate(newValue)
    }

    handle_keyDown(e) {
        if (e.keyCode == 13) {
            super.focusNextNode(e);
        }
    }

    render() {

        const{
            disabled,
            name,
            label,
            labelOn,
            rootData:{
                requiredData,
                errors,
                values
            },
            options,
            className,
            style,
            checkedValue,
            customStyle
        } = this.props
        
        const columnObject = Convert.key_split(name)
        const value = values&&values[columnObject.column]
        const validate_message = errors&&errors[columnObject.column]

        const newName = name + this.props.uniqueKey
        
        return (
            <>
                {
                    labelOn &&
                    <Label for={newName} className="search-text-order">
                        {label}
                        ：
                    </Label>
                }
                {
                    options?options.map((option)=>{
                        return <label>
                            <Input type="checkbox" name={`${newName}-${option.label}`} id={`${newName}-${option.label}`} checked={value&&value.find(singleValue=>singleValue==option.value)} onChange={this.handle_change} value={option.value} className={`tabable`} onKeyDown={(e)=>this.handle_keyDown(e)} />{option.label}&nbsp;
                        </label>
                    }):
                    customStyle?(<>
                        <Input type="checkbox" name={newName}  disabled={disabled} id={newName} checked={value===checkedValue} onChange={this.handle_change} className={customStyle + `__input`} onKeyDown={(e)=>this.handle_keyDown(e) } />
                        <label className={customStyle + `__label`} for={newName}></label>
                        </>
                    )
                    :(
                    <label>
                        <Input type="checkbox" name={newName}  disabled={disabled} id={newName} checked={value===checkedValue} onChange={this.handle_change} className={`tabable`} onKeyDown={(e)=>this.handle_keyDown(e) } />{label}&nbsp;
                    </label>
                    )
                }
                {
                    validate_message instanceof Array && validate_message.length>0 &&
                    <p id={newName} style={{ color: "red" }}>{validate_message.length>0?validate_message[0]:validate_message}</p>
                }
            </>
        );
    }
}
